export const formatDate = () => {
  const addZero = (i) => {
    if (i < 10) {
      i = '0' + i;
    }
    return i;
  };

  let today = new Date();
  let dd = today.getDate();
  let mm = today.getMonth() + 1;
  let yyyy = today.getFullYear();
  dd = addZero(dd);
  mm = addZero(mm);
  return `${dd}/${mm}/${yyyy}`;
};
